import { create } from 'zustand';
import type { SourceWindow } from '../../viewer/window/windowing';

/**
 * A window copied from one X-ray's box, to paste onto another (user,
 * 2026-10-16). Kept in the file's own numbers — the width and level its
 * readout says — so it means the same on an X-ray stored the other way up.
 * For the session only: going to another image keeps it, a reload does not.
 */
interface WindowClipboard {
  copied: SourceWindow | null;
  copy(window: SourceWindow): void;
}

export const useWindowClipboard = create<WindowClipboard>((set) => ({
  copied: null,
  copy: (copied) => set({ copied }),
}));
